module.exports = __webpack_public_path__ + "img/slide1.3c0adc4f.jpg";